import request from '@/utils/request';

export function updateStatusPremium(data) {
	return request({
		url: '/open/dashboard/updateStatusPremium',
		method: 'post',
		data: data,
	});
}
export function refund(data) {
	return request({
		url: '/open/dashboard/refund',
		method: 'post',
		data: data,
	});
}
export function opendashboard(query) {
	return request({
		url: '/open/dashboard',
		method: 'get',
		params: query,
	});
}
export function dashboardsendMail(data) {
	return request({
		url: '/open/dashboard/sendMail',
		method: 'post',
		data: data,
	});
}
export function dashboardupdateStatus(data) {
	return request({
		url: '/open/dashboard/updateStatus',
		method: 'post',
		data: data,
	});
}
export function dashboardhistoryList(query) {
	return request({
		url: '/open/dashboard/historyList',
		method: 'get',
		params: query,
	});
}
export function realTimetongji(query) {
	return request({
		url: '/realTime/tongji',
		method: 'get',
		params: query,
	});
}
export function realTimegetRealTime(query) {
	return request({
		url: '/realTime/getRealTime',
		method: 'get',
		params: query,
	});
}
export function dashboardedit(data) {
	return request({
		url: '/open/dashboard/edit',
		method: 'put',
		data: data,
	});
}
//获取验证码
export function sendCode(params) {
	return request({
		url: '/open/login/sendCode',
		method: 'get',
		params,
	});
}
//重置密码

export function updatePwd(data) {
	return request({
		url: '/open/dashboard/forgetPassword',
		method: 'post',
		data,
	});
}
//注册
export function register2(data) {
	return request({
		url: '/register2',
		method: 'post',
		data,
	});
}
//登录
export function login(data) {
	return request({
		url: '/login',
		method: 'post',
		data,
	});
}
//获取订单号

export function getOrderNoList(params) {
	return request({
		url: '/open/dashboard/getOrderNoList',
		method: 'get',
		params,
	});
}
export function getgoogle(data) {
	return request({
		url: '/open/login/google',
		method: 'post',
		data,
	});
}
